import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

type PurchaseEventData = {
  productId: string;
  price: number; // Price in dollars (will be converted to cents for tracking)
  currency?: string;
  transactionType?: 'membership' | 'donation';
  paymentMethod?:
    | 'iap'
    | 'credit_card'
    | 'apple_pay'
    | 'paypal'
    | 'paypal_billing_agreement';
  isUpgrade?: boolean;
};

export const usePurchaseTracking = (): {
  logPurchaseEvent: (data: PurchaseEventData) => void;
} => {
  const posthog = usePostHog();

  const logPurchaseEvent = useCallback(
    (data: PurchaseEventData): void => {
      // Convert price from dollars to cents (integer)
      const {
        price,
        productId,
        currency = 'USD',
        transactionType,
        paymentMethod,
        isUpgrade = false,
      } = data;
      const priceInCents = Math.round(price * 100);

      posthog.capture('purchase', {
        productId,
        priceCents: priceInCents,
        currency,
        transactionType,
        paymentMethod,
        isUpgrade,
      });
    },
    [posthog],
  );

  return { logPurchaseEvent };
};
